import React from "react";
import Channel from "./Channel";
import "./styles.scss";
import FullPageSpinner from "../../../FullPageSpinner";
import _ from "lodash";

export default ({
  channels,
  selectedChannel,
  channelsLister,
  onSelectChannel,
  loadMore
}) => {
  if (_.isNull(selectedChannel) && channels && channels.length)
    onSelectChannel(channels[0]);
  return channelsLister && channelsLister.isLoading ? (
    <FullPageSpinner />
  ) : (
    <ul id="channels">
      {channels &&
        channels.map((channel, i) => (
          <Channel
            key={channel.url}
            channel={channel}
            isSelected={selectedChannel && selectedChannel.url === channel.url}
            onSelectChannel={onSelectChannel}
          />
        ))}
    </ul>
  );
};
